import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';

import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { Link } from '@mui/material';

import { clearAggridReducer } from '../../../../actions/agGrid';
import { navigation } from '../../../../constants/menu-items';
import { getAllowedNavigationItems } from '../../../../utils/menu';
import ComboBoxAutocomplete from '../../../Reusable/ComboBoxAutocomplete';

const MenuSearch = (props) => {
  const history = useHistory();
  const { allowedActions, t, gt, collapseMenu, windowWidth } = props || [],
    { Placeholders } = gt || {};

  const allowedNavigationItems = getAllowedNavigationItems(
    navigation(t).items,
    allowedActions
  );

  function getMenuItems() {
    let itemsForCombo = [];
    allowedNavigationItems.forEach((item) => {
      !!item?.url &&
        itemsForCombo.push({ id: item.id, title: item.title, url: item.url });
      if (item?.children?.length > 0) {
        const itemChildrenForCombo = item.children?.map((c) => ({
          id: c.id,
          title: c.title,
          url: c.url,
          parent: item.title,
        }));
        itemsForCombo.push(...itemChildrenForCombo);
        item.children?.forEach((child) => {
          if (child?.children) {
            const childChildrenForCombo = child.children?.map((c) => ({
              id: c.id,
              title: c.title,
              url: c.url,
              ancestor: item.title,
              parent: child.title,
            }));
            itemsForCombo.push(...childChildrenForCombo);
          }
        });
      }
    });
    return itemsForCombo?.filter((i) => i.url);
  }

  const onComboBoxChangeHandler = (value) => {
    const path = value?.url;
    if (path && history?.location?.pathname !== path) {
      //TODO dodati uslov za ovu akciju
      clearAggridReducer();
      if (value.external) {
        const target = value.target ? '_blank' : '';
        window.open(path, target);
        return;
      }
      history.push(path);
    }
  };

  const menuItems = getMenuItems();
  const isMinimized = windowWidth < 992;

  return (windowWidth >= 992 && collapseMenu) ||
    (isMinimized && !collapseMenu) ? (
    <Fragment />
  ) : (
    <div className="search-container-content">
      <ComboBoxAutocomplete
        id="searchAutocomplete"
        data={menuItems}
        textExtractor={(a) => a.title}
        changeValue={onComboBoxChangeHandler}
        startAdornment={<SearchRoundedIcon className="gray-icon-color" />}
        placeholder={Placeholders?.search}
        margin="none"
        variant="filled"
        hiddenLabel
        renderOption={(option) => {
          let description = option.title;
          if (option.ancestor)
            description = `${option.ancestor} > ${option.parent} > ${description}`;
          else if (option.parent)
            description = `${option.parent} > ${description}`;
          return (
            <section className="m-0 p-0">
              <small>
                <Link href="#" className="p-0 d-flex flex-row">
                  <b>{option.title}</b>
                </Link>
                <span className="small-font gray-icon-color">
                  {description}
                </span>
              </small>
            </section>
          );
        }}
        optionBoxStyle={{ borderBottom: '1px dashed #ccc' }}
        objectSearch={true}
      />
    </div>
  );
};

export default MenuSearch;
